module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('a', [_c('i', [_c('icon', {
    attrs: {
      "name": "file-text-o",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "secondary"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "search",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "secondary"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "arrow-circle-up",
      "scale": "2"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "switch-panel",
    attrs: {
      "id": "swichPanel"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.switchToTraditional()
      }
    }
  }, [_vm._v("< Switch to Traditional Reading Experience")])])]), _vm._v(" "), (_vm.prevPage) ? _c('div', {
    staticClass: "nav-btn btn-top",
    on: {
      "click": function($event) {
        _vm.navigateTop()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-up",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nextPage) ? _c('div', {
    staticClass: "nav-btn btn-bottom",
    on: {
      "click": function($event) {
        _vm.navigateBottom()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-down",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.prevSlide) ? _c('div', {
    class: {
      'nav-btn': true, 'btn-left': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.navigateLeft()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-left",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nextSlide) ? _c('div', {
    class: {
      'nav-btn': true, 'btn-right': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    on: {
      "click": function($event) {
        _vm.navigateRight()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "caret-right",
      "scale": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe",
      value: (_vm.swipeHandler),
      expression: "swipeHandler",
      arg: "swipe"
    }],
    class: {
      'enhanced-container': true, 'has-nav-top': _vm.prevPage, 'has-nav-bottom': _vm.nextPage
    },
    attrs: {
      "id": "enhanced-container"
    }
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "primary"
  }, [_c('i', [_vm._v("Submit Paper")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03cc34d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/EnhancedViewComponent.vue
// module id = 1379
// module chunks = 1